import { render, staticRenderFns } from "./FairLabel.vue?vue&type=template&id=d9a137fa&scoped=true&"
import script from "./FairLabel.vue?vue&type=script&lang=js&"
export * from "./FairLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a137fa",
  null
  
)

component.options.__file = "FairLabel.vue"
export default component.exports